import { getBodySingleWagesQuery } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodySingleWages/getBodySingleWagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBodySingleWagesQueryOptions = ({
  id,
  wages_id,
}: {
  id: number;
  wages_id: number;
}) =>
  queryOptions({
    queryKey: ['getBodySingleWages', id, wages_id],
    queryFn: () => getBodySingleWagesQuery({ id, wages_id }),
    enabled: false,
    select: (data) => {
      return {
        count: data?.count,
        total_price: data?.total_price,
        wages: {
          id: data?.wages?.id,
          title: {
            label: data?.wages?.title,
            value: Math.random(),
          },
          price: data?.wages?.price,
        },
      };
    },
  });
